var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 260.28,
    y1: 166.78,
    x2: 1786.96,
    y2: 1886.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ae30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1020.43,
    y1: 1020.11,
    x2: 1707.05,
    y2: 1695.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4901f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 311.24,
    y1: 300.26,
    x2: 793.99,
    y2: 790.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 563.76,
    y1: 542.49,
    x2: 760.32,
    y2: 782.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ae30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1244.05,
    y1: 546.44,
    x2: 1440.61,
    y2: 776.74,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 591.08,
    y1: 575.88,
    x2: 731.54,
    y2: 747.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1271.58,
    y1: 578.69,
    x2: 1412.05,
    y2: 743.28,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1000,
    y1: 1309.31,
    x2: 1000,
    y2: 1667.4,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1000,
    y1: 1289.45,
    x2: 1000,
    y2: 1558.01,
    xlinkHref: "#linear-gradient-6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1000,1998.87C449.22,1998.87,1.13,1550.78,1.13,1000S449.22,1.13,1000,1.13s998.87,448.09,998.87,998.87-448.09,998.87-998.87,998.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.02,1705.98c180.87,180.87,430.59,292.89,705.98,292.89,550.78,0,998.87-448.09,998.87-998.87,0-275.39-112.02-525.11-292.89-705.98L294.02,1705.98Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M545.97,1454.03c0-500.7,407.37-908.06,908.06-908.06,133.01,0,259.03,29.45,372.98,81.05C1684.35,312.02,1367.69,91.94,1000,91.94c-500.7,0-908.06,407.37-908.06,908.06,0,367.69,220.08,684.35,535.09,827.01-51.61-113.95-81.05-239.97-81.05-372.98Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659.48,818.39c-87.61,0-158.91-71.3-158.91-158.91s71.3-158.91,158.91-158.91,158.91,71.3,158.91,158.91-71.3,158.91-158.91,158.91Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1340.52,818.39c-87.61,0-158.91-71.3-158.91-158.91s71.3-158.91,158.91-158.91,158.91,71.3,158.91,158.91-71.3,158.91-158.91,158.91Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 659.48,
    cy: 659.48,
    r: 113.51
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1340.52,
    cy: 659.48,
    r: 113.51
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1000,1590.24c-359.1,0-519.99-209.04-526.66-217.93-14.57-19.4-20.68-43.32-17.27-67.33,3.44-24.03,16.01-45.27,35.43-59.81,15.85-11.88,34.67-18.16,54.43-18.16,28.64,0,55.02,13.1,72.38,35.91,4.43,5.76,115.19,145.7,381.69,145.7s377.1-139.8,381.74-145.74c16.74-22.3,43.9-35.87,72.34-35.87,19.75,0,38.6,6.27,54.45,18.16,19.4,14.54,31.97,35.78,35.4,59.81,3.41,24.01-2.7,47.93-17.27,67.33-6.67,8.89-167.56,217.93-526.66,217.93Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1000,1544.84c-336.64,0-484.23-191.61-490.35-199.77-15.05-20.06-11-48.53,9.07-63.56,20.06-15.03,48.33-10.97,63.45,8.91,5.45,7.09,129.25,163.61,417.83,163.61s416.48-161.82,417.72-163.46c15.03-20.02,43.45-24.14,63.56-9.07,20.06,15.03,24.12,43.5,9.07,63.56-6.12,8.16-153.7,199.77-490.35,199.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileFace);
export default __webpack_public_path__ + "static/media/Smile Face.6c1d2cbaa8d78bec00f2668bcefd556d.svg";
export { ForwardRef as ReactComponent };